import Vue from 'vue';

import './assets/scss/main.scss';

import './plugins';
import './initializers';

import './registerServiceWorker';

import i18n from './plugins/vue-i18n';
import oauth from './plugins/oauth';

import App from './App.vue';
import router from './router';

import { DEVTOOLS, PRODUCTION_TIP } from './config';
import { initMarketingParams } from './initializers/analytics';
import { saveFrameQueryParams } from './initializers/frame-query-params';
import { GTMEvent, addGtmEvent } from './helpers/gtm';

Vue.config.devtools = DEVTOOLS;
Vue.config.productionTip = PRODUCTION_TIP;

Vue.prototype.$appName = undefined;

saveFrameQueryParams();

initMarketingParams().finally(() => {
  addGtmEvent(GTMEvent.DATA_READY_TO_INIT);

  new Vue({
    i18n,
    oauth,
    router,
    render: h => h(App),
  }).$mount('#app');
});
